import styled from 'styled-components'

const WrapQueries = styled.div`
    
`;

export {
    WrapQueries
}